<template>
	<button v-if="!showCounter || !getProduct" class="button button--primary add-to-cart" :class="{ 'add-to-cart--active': !showCounter && getProduct }" type="button" :aria-label="buttonText !== undefined ? undefined : defaultButtonText" @click="handleButtonClick">
		<template v-if="buttonText !== undefined">{{ buttonText || defaultButtonText }}</template>
	</button>
	<CounterComponent v-else :value="value" :max="max" @change="handleCounterChange" />
</template>

<script setup lang="ts">
import CounterComponent from '@/shared/common/counter/counter-component.vue';
import { computed } from 'vue';

const defaultButtonText = 'В корзину';

interface Props {
	id: string;
	showCounter?: boolean;
	buttonText?: string;
}

const props = withDefaults(defineProps<Props>(), {
	showCounter: false,
	buttonText: undefined,
});

const { cart: store } = window.app.store;

const getProduct = computed(() => store.getProduct(props.id));
const value = computed(() => store.getQuantity(props.id));
const max = computed(() => store.getMaxOfProduct(props.id));

const handleButtonClick = (): void => {
	if (!props.showCounter && getProduct.value) {
		store.removeFromCart({ productId: props.id });
		return;
	}

	store.addToCart({ productId: props.id, quantity: 1 });
};

const handleCounterChange = (value: number): void => {
	if (value === 0) store.removeFromCart({ productId: props.id, quantity: 1 });
	else store.setProductQuantity({ productId: props.id, quantity: value });
};
</script>
